import { useTranslation } from 'next-i18next';
import { useServices } from '@/context/ServicesProvider';
import React, { useEffect } from 'react';
import { TipoPeriodoTelemetry } from '@/objects/Telemetry';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import CardDato from '@/components/elements/CardDato';


function TotalLibros() {
    const { t } = useTranslation();
    const { telemetryQueries } = useServices();

    const [totalLibros, setTotalLibros] = React.useState<number>(0);
    const [totalLibrosHoy, setTotalLibrosHoy] = React.useState<number>(0);
    const [totalLibrosMes, setTotalLibrosMes] = React.useState<number>(0);
    const [totalLibrosSemana, setTotalLibrosSemana] = React.useState<number>(0);


    useEffect(() => {
        cargarEstadisticas();
    }, []);

    function cargarEstadisticas() {
        telemetryQueries?.obtenerTotalLibros(TipoPeriodoTelemetry.TOTAL).then((response) => {
            if (response.status == 200) {
                setTotalLibros(response.data.total);
            }
        }).catch((error) => {
            console.log('Error al cargar total libros', error);
        });
        telemetryQueries?.obtenerTotalLibros(TipoPeriodoTelemetry.DIA).then((response) => {
            if (response.status == 200) {
                setTotalLibrosHoy(response.data.total);
            }
        }).catch((error) => {
            console.log('Error al cargar total libros hoy', error);
        });
        telemetryQueries?.obtenerTotalLibros(TipoPeriodoTelemetry.MES).then((response) => {
            if (response.status == 200) {
                setTotalLibrosMes(response.data.total);
            }
        }).catch((error) => {
            console.log('Error al cargar total libros mes', error);
        });
        telemetryQueries?.obtenerTotalLibros(TipoPeriodoTelemetry.SEMANA).then((response) => {
            if (response.status == 200) {
                setTotalLibrosSemana(response.data.total);
            }
        }).catch((error) => {
            console.log('Error al cargar total libros semana', error);
        });

    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', width: "100%" }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', width: '100%' }}>
                    <TituloSeccionH2 texto={t("menu:secciones.estadisticas.libros.total_libros")} />
                </div>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                        alignItems: 'stretch',
                        width: '100%',
                        maxWidth: '100%',
                        gap: '1em',
                        padding: '1em',
                        boxSizing: 'border-box'
                    }}
                >
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalLibrosHoy.toString()} titulo={`${t("menu:secciones.estadisticas.hoy")}`} digitAnimated={true} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalLibrosSemana.toString()} titulo={`${t("menu:secciones.estadisticas.semana")}`} digitAnimated={true} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalLibrosMes.toString()} titulo={`${t("menu:secciones.estadisticas.mes")}`} digitAnimated={true} />
                    </div>
                    <div style={{ width: '100%' }}>
                        <CardDato texto={totalLibros.toString()} titulo={t("menu:secciones.estadisticas.total")} digitAnimated={true} />
                    </div>
                </div>
            </section>
        </section>
    );
}

export default TotalLibros;